// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"05644c37","148":"11445558","238":"794e597d","327":"3485b7b0","883":"3485b7b0","889":"acd8d387"}[chunkId] + ".chunk.css";
};